"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceLocator = void 0;
var ServiceLocator = /** @class */ (function () {
    function ServiceLocator(initBaseServices) {
        this.values = {};
        this.initialized = {};
        this.isInitialized = false;
        this.initBaseServices = initBaseServices;
    }
    ServiceLocator.prototype.set = function (key, value) {
        this.values[key] = value;
    };
    ServiceLocator.prototype.get = function (key) {
        if (!this.isInitialized) {
            this.initBaseServices(this);
            this.isInitialized = true;
        }
        var service = this.initialized[key];
        if (service) {
            return service;
        }
        var creator = this.values[key];
        if (!creator) {
            var msg = "Service with id " + key + " does not exists";
            throw new Error(msg);
        }
        service = creator();
        this.initialized[key] = service;
        return service;
    };
    return ServiceLocator;
}());
exports.ServiceLocator = ServiceLocator;
//# sourceMappingURL=ServiceLocator.js.map